import { find } from 'ramda';
import { IContact } from '../../../../common/models/contact/IContact';
import { IRequestAdditionalReferences } from '../../../../common/models/referenceRequest/IRequestAdditionalReferences';
import { IProfileCandidate } from '../../../../common/models/candidate/IProfileCandidate';
import { IFormattedMessage } from '../../../../common/models/common/IFormattedMessage';
import { IconType } from '../../../../components/Icon';
import { IBindingAction } from '../../../../common/models/callback';

export type CandidateActionType = 'archive' |
  'unarchive' |
  'reminder' |
  'requestMore' |
  'reassign' |
  'position' |
  'edit';

export interface ICandidateAction extends IFormattedMessage {
  type: CandidateActionType;
  icon: IconType;
  action?: IBindingAction;
}

const editAction: ICandidateAction = {
  type: 'edit',
  id: 'candidateActions.edit',
  defaultMessage: 'Edit name, email, phone',
  icon: 'pencil'
};

export const getInactiveActions = (unarchive: IBindingAction): ICandidateAction[] => [{
  type: 'unarchive',
  id: 'candidateActions.unarchive',
  defaultMessage: 'Unarchive candidate',
  icon: 'unarchive',
  action: unarchive
}, editAction];

export const getActiveActions = (requestMore: IBindingAction): ICandidateAction[] => [{
  type: 'archive',
  id: 'bulkActions.archiveCandidate',
  defaultMessage: 'Archive candidate',
  icon: 'archive'
}, {
  type: 'reminder',
  id: 'candidateActions.reminder',
  defaultMessage: 'Send reminder to finish',
  icon: 'reminder'
}, {
  type: 'requestMore',
  id: 'candidateActions.moreRef',
  defaultMessage: 'Request more references',
  icon: 'userPlus',
  action: requestMore
}, {
  type: 'reassign',
  id: 'candidateActions.reassign',
  defaultMessage: 'Reassign to different user',
  icon: 'userChange'
}, {
  type: 'position',
  id: 'candidateActions.changePosition',
  defaultMessage: 'Change position',
  icon: 'position'
}, editAction];

export const mapContactToIReqAdditionalReferences = (
  { id, candidates, firstName, lastName, email, phoneNumber }: IContact,
  candidateData: IProfileCandidate,
  candidateId: string
): IRequestAdditionalReferences => {
  const candidate = find(positionCandidate => candidateId === positionCandidate.id, candidates);
  const position = candidate?.positionId ? { id: candidate.positionId, name: candidate.positionName } : undefined;
  return {
    candidates: [{
      id,
      firstName,
      lastName,
      email,
      phoneNumber,
      activeCandidate: {
        id: candidateId,
        refCount: candidateData.referenceCounters.total,
        position: position?.name
      } }],
    selectedPosition: position
  };
};
